/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_sci_plot_dataset_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dataset name`)
};

const es_sci_plot_dataset_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre del conjunto de datos`)
};

const de_sci_plot_dataset_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name des Datensatzes`)
};

const nl_sci_plot_dataset_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Naam van dataset`)
};

const fr_sci_plot_dataset_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nom du jeu de données`)
};

const it_sci_plot_dataset_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome del dataset`)
};

const pt_br2_sci_plot_dataset_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome do conjunto de dados`)
};

const pt_sci_plot_dataset_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome do conjunto de dados`)
};

const ja_sci_plot_dataset_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`データセット名`)
};

const zh_sci_plot_dataset_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`数据集名称`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const sci_plot_dataset_name = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.sci_plot_dataset_name(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("sci_plot_dataset_name", locale)
	if (locale === "en") return en_sci_plot_dataset_name(inputs)
	if (locale === "es") return es_sci_plot_dataset_name(inputs)
	if (locale === "de") return de_sci_plot_dataset_name(inputs)
	if (locale === "nl") return nl_sci_plot_dataset_name(inputs)
	if (locale === "fr") return fr_sci_plot_dataset_name(inputs)
	if (locale === "it") return it_sci_plot_dataset_name(inputs)
	if (locale === "pt-BR") return pt_br2_sci_plot_dataset_name(inputs)
	if (locale === "pt") return pt_sci_plot_dataset_name(inputs)
	if (locale === "ja") return ja_sci_plot_dataset_name(inputs)
	return zh_sci_plot_dataset_name(inputs)
};